module.exports = __webpack_public_path__ + "img/flutterwave.03837626.png";